export default Object.freeze({
  Text: 'text',
  TextMultiple: 'text-multiple',
  Int32: 'int-32',
  Int: 'int',
  Decimal: 'decimal',
  Boolean: 'boolean',
  DateTime: 'date-time',
  Date: 'date',
  Time: 'time',
  Choice: 'choice',
  DataBaseRemoteSearch: 'database-remote-search',
  DataBaseRemoteList: 'database-remote-list',
  WebServiceRemoteSearch: 'webservice-remote-search',
  WebServiceRemoteList: 'webservice-remote-list',
  SelectorUser: 'selector-user',
  SelectorPosition: 'selector-position',
  SelectorUserGroup: 'selector-user-group',
  Table: 'table',
  Attachment: 'attachment',
  AutoCalculatedByTableColumn: 'auto-calculated-by-table-column',
  FieldDynamicEntityList: 'field-dynamic-entity-list',
  CalculatedByFormula: 'calculated-by-formula',
  Image: 'image',
  Photo: 'photo',
  Signature: 'signature',
  GoToAction: 'goto-action',
  Slider: 'slider',
  FieldDynamicEntitySearch: 'field-dynamic-entity-search',
  SelectorArea: 'selector-area',
  RadioGroup: 'radio-group',
  CheckGroup: 'check-group',
  Url: 'url',
  Email: 'email',
  Location: 'location',
  Password: 'password',
  LikertScale: 'likert-scale',
});
